<template>
  <div class="all-cons">
    <div id="" class="home-subset">
      <div class="search">
        <div class="search-d">
          <span>关键字</span>
          <el-input
            class="search-inp"
            v-model="Keyword"
            placeholder="请输入内容"
          ></el-input>
        </div>

        <div class="search-but">
          <span class="search-inquire" @click="inquire">查询</span>
          <span class="search-empty" @click="reset">重置</span>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-all">
        <div class="table-top">
          <!-- <span class="table-but1">添加车辆</span> -->
          <span class="table-but1">批量导入</span>
          <span class="table-but2">导入模板下载</span>
          <span class="table-but3">导出</span>
          <!-- <span class="table-but3">分配</span> -->
          <!-- <span class="table-but3">查看详情</span> -->
        </div>

        <el-table
          v-loading="tableLoading"
          :data="tableData"
          :empty-text="emptyText"
          :header-cell-style="{
            'text-align': 'center',
            'background-color': '#fafafa',
            color: 'rgba(0, 0, 0, 0.85)',
          }"
          :cell-style="{ 'text-align': 'center', color: 'rgba(0, 0, 0, 0.65)' }"
          style="width: 100%"
          height="618"
          @sort-change="sortChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>

          <el-table-column
            v-for="(item, index) in list"
            :key="index"
            :show-overflow-tooltip="true"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :sortable="item.sortable"
          />

          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                style="color: #ffad1f;"
                @click="auditClick(scope.row)"
                >调研</el-button
              >
              <!-- <el-button v-if="scope.row.isAudit == true" type="text" size="small"
									style="color: #28acb8;" @click="setCharge(scope.row)">设置</el-button> -->
              <!-- <el-button type="text" size="small" @click="handleClick(scope.row)">查看</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          background
          :current-page="pagenum"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          class="paging"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="调研"
      :visible.sync="dialogAudit"
      width="600"
    >
      <el-form :model="form">
        <el-form-item label="公司名称:" label-width="200">
          <span>{{ form.name }}</span>
        </el-form-item>
        <el-form-item label="授权业务联系人:" label-width="200">
          <span>{{ form.contact }}</span>
        </el-form-item>
        <el-form-item label="授权业务联系人电话:" label-width="200">
          <span>{{ form.contactPhone }}</span>
        </el-form-item>

        <el-form-item label="公司员工数:" label-width="200">
          <el-input
            style="width: 50%;"
            type="text"
            placeholder="请输入内容"
            v-model="form.explain"
          ></el-input>
        </el-form-item>
        <el-form-item label="主要运输货物:" label-width="200">
          <el-input
            style="width: 50%;"
            type="text"
            placeholder="请输入内容"
            v-model="form.explain"
          ></el-input>
        </el-form-item>
        <el-form-item label="上一年度营业额（万元）:" label-width="200">
          <el-input
            style="width: 50%;"
            type="text"
            placeholder="请输入内容"
            v-model="form.explain"
          ></el-input>
        </el-form-item>

        <el-form-item label="是否有业务系统:" label-width="200">
          <el-select v-model="form.region" placeholder="请选择">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否继续使用业务系统:" label-width="200">
          <el-select v-model="form.region" placeholder="请选择">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有自有车队:" label-width="200">
          <el-select v-model="form.region" placeholder="请选择">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="自有车队规模:" label-width="200">
          <el-input
            style="width: 50%;"
            type="text"
            placeholder="请输入内容"
            v-model="form.explain"
          ></el-input>
        </el-form-item>
        <el-form-item label="合作车辆数量:" label-width="200">
          <el-input
            style="width: 50%;"
            type="text"
            placeholder="请输入内容"
            v-model="form.explain"
          ></el-input>
        </el-form-item>
        <el-form-item label="驾驶员数量:" label-width="200">
          <el-input
            style="width: 50%;"
            type="text"
            placeholder="请输入内容"
            v-model="form.explain"
          ></el-input>
        </el-form-item>
        <el-form-item label="其他:" label-width="200">
          <el-input
            style="width: 50%;"
            type="text"
            placeholder="请输入内容"
            v-model="form.explain"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAudit = false">取 消</el-button>
        <!-- <el-button type="primary" @click="submitAudit">确 定</el-button> -->
        <el-button type="primary" @click="dialogAudit = false">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="公司收费设置"
      :visible.sync="dialogCharge"
      width="600px"
    >
      <el-form :model="charge">
        <el-form-item label="公司简称:" label-width="200">
          <span>{{ charge.tenancyName }}</span>
        </el-form-item>
        <el-form-item label="单位全称:" label-width="200">
          <span>{{ charge.name }}</span>
        </el-form-item>
        <el-form-item label="公司缴费类型:" label-width="200">
          <el-select v-model="charge.type" placeholder="请选择缴费类型">
            <el-option
              v-for="(item, index) in chargeTypeList"
              :label="item.name"
              :value="item.value"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="charge.type == 2"
          label="包年到期时间:"
          label-width="200"
        >
          <el-date-picker size="small" 
            v-model="charge.time"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCharge = false">取 消</el-button>
        <el-button type="primary" @click="submitCharge">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="信息详情"
      :visible.sync="lookMessage"
      width="80%"
    >
      <div class="message-list">
        <!-- <div>
					<span>单位全称：</span>
					<span>{{ messages.name }}</span>
				</div> -->
        <div>
          <span>公司名称：</span>
          <span>{{ messages.tenancyName }}</span>
        </div>
        <div>
          <span>租户类型：</span>
          <span v-if="messages.tenantStyle == 2">物流企业</span>
          <span v-if="messages.tenantStyle == 1">执法部门</span>
        </div>
        <div>
          <span>公司电话：</span>
          <span>{{ messages.tenantPhone }}</span>
        </div>
        <div>
          <span>公司地址：</span>
          <span>{{ messages.address }}</span>
        </div>
        <div>
          <span>公司法人：</span>
          <span>{{ messages.legalPerson }}</span>
        </div>
        <div>
          <span>法人联系电话：</span>
          <span>{{ messages.legalPersonPhone }}</span>
        </div>
        <div>
          <span>公司主要负责人：</span>
          <span>{{ messages.contact }}</span>
        </div>
        <div>
          <span>公司主要负责人电话：</span>
          <span>{{ messages.contactPhone }}</span>
        </div>
        <div>
          <span>公司邮箱：</span>
          <span>{{ messages.tenantEmail }}</span>
        </div>
        <div>
          <span>公司缴费类型：</span>
          <span>{{ messages.tenantPaymentTypeText }}</span>
        </div>
        <div v-if="messages.tenantPaymentType == 2">
          <span>包年到期时间：</span>
          <span>{{ messages.overTime | dCreateTime }}</span>
        </div>
        <div>
          <span>公司组织代码：</span>
          <span>{{ messages.organizationCode }}</span>
        </div>
        <div>
          <span>道路运输经营许可证号：</span>
          <span>{{ messages.businessLicense }}</span>
        </div>
        <div>
          <span>交换代码：</span>
          <span>{{ messages.senderCode }}</span>
        </div>
        <!-- <div>
					<span>是否审核：</span>
					<span v-if="messages.isAudit == true">审核通过</span>
					<span v-else-if="messages.isAudit == false">审核不通过</span>
					<span v-else>未审核</span>
					
					<span>审核通过</span>
				</div> -->
        <div>
          <span>注册日期：</span>
          <span>{{ messages.creationTime | dCreateTime }}</span>
        </div>
        <div>
          <span>私钥：</span>
          <span>{{ messages.privateKey }}</span>
        </div>
        <div>
          <span>公钥：</span>
          <span>{{ messages.publicKey }}</span>
        </div>
        <div>
          <span>IP地址：</span>
          <span>{{ messages.ip }}</span>
        </div>
        <div>
          <span>所在省市县：</span>
          <span>{{ messages.shortName }}</span>
        </div>
        <div>
          <span>审核说明：</span>
          <span>{{ messages.auditRemark }}</span>
        </div>

        <div style="display: flex;">
          <span>营业执照图片：</span>
          <img v-show="idImg1" src="" ref="img1" @click="imgMax('img1s')" />
        </div>
        <div style="display: flex;">
          <span>道路运输经营许可证图片：</span>
          <img v-show="idImg2" src="" ref="img2" @click="imgMax('img2s')" />
        </div>
        <div style="display: flex;">
          <span>法人身份证图片：</span>
          <img v-show="idImg3" src="" ref="img3" @click="imgMax('img3s')" />
        </div>
        <div style="display: flex;">
          <span>主要负责人身份证图片：</span>
          <img v-show="idImg4" src="" ref="img4" @click="imgMax('img4s')" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="verification(messages.id)"
          >核 验</el-button
        >
        <el-button type="primary" @click="lookMessage = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 图片大图预览 -->
    <div class="maxImg" v-show="imgMax1">
      <div class="shade" @click="closeImgMax"></div>
      <div class="maxImg-s">
        <img class="maxImg-subject" src="" ref="img1s" />
        <img
          class="maxImg-close"
          @click="closeImgMax"
          src="@/assets/images/close.png"
        />
      </div>
    </div>
    <div class="maxImg" v-show="imgMax2">
      <div class="shade" @click="closeImgMax"></div>
      <div class="maxImg-s">
        <img class="maxImg-subject" src="" ref="img2s" />
        <img
          class="maxImg-close"
          @click="closeImgMax"
          src="@/assets/images/close.png"
        />
      </div>
    </div>
    <div class="maxImg" v-show="imgMax3">
      <div class="shade" @click="closeImgMax"></div>
      <div class="maxImg-s">
        <img class="maxImg-subject" src="" ref="img3s" />
        <img
          class="maxImg-close"
          @click="closeImgMax"
          src="@/assets/images/close.png"
        />
      </div>
    </div>
    <div class="maxImg" v-show="imgMax4">
      <div class="shade" @click="closeImgMax"></div>
      <div class="maxImg-s">
        <img class="maxImg-subject" src="" ref="img4s" />
        <img
          class="maxImg-close"
          @click="closeImgMax"
          src="@/assets/images/close.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  created() {
    this.userNames = localStorage.getItem("name");
    this.loginName = localStorage.getItem("loginName");
  },
  data() {
    return {
      loginName: "",
      userNames: "",
      userImg: require("@/assets/images/user.png"),
      Keyword: "",

      // 表格里面的数据
      emptyText: "",
      tableLoading: true,
      tableData: [],
      // 分页数据
      pagenum: 1, // 当前页数
      SkipCount: 0, // 当前后台请求页数0页开始
      MaxResultCount: 10, // 每页显示条目个数
      total: 0, // 总条目数
      // 列表
      list: [
        // {
        // 	prop: "tenancyName",
        // 	label: "公司简称",
        // 	width: "150",
        // 	sortable: false,
        // },
        {
          prop: "name",
          label: "公司名称",
          width: "150",
          sortable: false,
        },
        {
          prop: "contact",
          label: "公司主要负责人",
          width: "150",
          sortable: false,
        },
        {
          prop: "contactPhone",
          label: "公司主要负责人电话",
          width: "150",
          sortable: false,
        },
        {
          prop: "tenantStyleText",
          label: "公司员工数(人)",
          width: "150",
          sortable: false,
        },
        // {
        // 	prop: "isAuditText",
        // 	width: "100",
        // 	label: "审核状态",
        // 	sortable: false,
        // },
        {
          prop: "creationTime",
          width: "150",
          label: "主要运输货物",
          sortable: false,
        },
        {
          prop: "tenantPhone",
          label: "是否有业务系统",
          width: "150",
          sortable: false,
        },
        {
          prop: "tenantPhone",
          label: "是否继续使用业务系统",
          sortable: false,
        },
        {
          prop: "legalPerson",
          label: "是否有自有车队",
          sortable: false,
        },
        // {
        // 	prop: "legalPersonPhone",
        // 	label: "自有车队规模",
        // 	width: "150",
        // 	sortable: false,
        // },

        // {
        // 	prop: "tenantPaymentTypeText",
        // 	label: "公司缴费类型",
        // 	width: "150",
        // 	sortable: false,
        // },
      ],

      // 调研
      form: "",
      charge: {
        id: "",
        time: "",
        type: "",
        name: "",
        tenancyName: "",
      },
      chargeTypeList: [],
      dialogCharge: false,
      dialogAudit: false,
      lookMessage: false,
      messages: "",
      idImg1: false,
      idImg2: false,
      idImg3: false,
      idImg4: false,
      imgMax1: false,
      imgMax2: false,
      imgMax3: false,
      imgMax4: false,
    };
  },
  filters: {
    dCreateTime(data) {
      var date = new Date(data);
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        date
          .getDate()
          .toString()
          .padStart(2, 0) + " ";
      var h =
        date
          .getHours()
          .toString()
          .padStart(2, 0) + ":";
      var m = date
        .getMinutes()
        .toString()
        .padStart(2, 0);
      var df = Y + M + D;
      return df;
    },
  },
  mounted() {
    this.getData();
    this.getChargeType();
  },
  methods: {
    // 导航路径跳转
    navPath(path) {
      this.$router.push({
        name: path,
      });
    },
    //退出登陆
    logOut() {
      this.$http.get("/api/TokenAuth/LogOut").then((res) => {
        if (res.data.success == true) {
          localStorage.clear();
          this.$router.push({
            name: "login",
          });
        }
      });
    },

    // 获取列表
    getData() {
      var that = this;
      that.emptyText = "数据加载中...";
      that.$http
        .get(
          "/api/services/app/Tenant/GetAll?Keyword=" +
            that.Keyword +
            "&IsActive=true&SkipCount=" +
            that.SkipCount +
            "&MaxResultCount=" +
            that.MaxResultCount
        )
        .then((res) => {
          if (res.data.success == true) {
            that.tableData = res.data.result.items;
            that.total = res.data.result.totalCount;

            if (res.data.result.items == null || res.data.result.items == "") {
              that.emptyText = "暂无数据";
            }

            that.tableData.forEach((el) => {
              // 格式化时间
              el.creationTime = that.$options.filters["dCreateTime"](
                el.creationTime
              );

              // if (el.tenantStyle == 1) {
              // 	el.tenantStyleText = "执法部门";
              // } else if (el.tenantStyle == 2) {
              // 	el.tenantStyleText = "物流企业";
              // } else if (el.tenantStyle == 3) {
              // 	el.tenantStyleText = "货主";
              // } else {
              // 	el.tenantStyleText = "";
              // }

              // if (el.isAudit == true) {
              // 	el.isAuditText = "审核通过";
              // } else if (el.isAudit == false) {
              // 	el.isAuditText = "审核不通过";
              // } else {
              // 	el.isAuditText = "未审核";
              // }
              el.tenantStyleText = "50~100";
              el.creationTime = "钢铁，煤炭";
              el.tenantPhone = "否";
              el.legalPerson = "是";
            });
          }

          that.tableLoading = false;
        })
        .catch((errors) => {
          that.tableLoading = false;
        });
    },
    // 排序
    sortChange(column) {
      // console.log(column);
    },
    // 查询
    inquire() {
      if (this.Keyword == "") {
        this.$message.error("查询条件不能为空");
        return;
      }
      this.SkipCount = 0;
      this.MaxResultCount = 10;
      this.getData();
    },
    // 重置
    reset() {
      this.Keyword = "";
      this.SkipCount = 0;
      this.MaxResultCount = 10;
      this.getData();
    },
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          resolve(e.target.result);
        };
        fileReader.readAsDataURL(blob);
        fileReader.onerror = () => {
          reject(new Error("文件流异常"));
        };
      });
    },
    // 查看
    handleClick(row) {
      var that = this;
      that.lookMessage = true;
      that.$http
        .post("/api/services/app/Tenant/GetTenantInfo", {
          id: row.id,
        })
        .then((res) => {
          if (res.data.success == true) {
            that.messages = res.data.result;

            if (
              res.data.result.organizationFileIds == "" ||
              res.data.result.organizationFileIds == null
            ) {
              that.idImg1 = false;
            } else {
              that.idImg1 = true;
              that.$http
                .get(
                  "/api/File/Attachment/" + res.data.result.organizationFileIds,
                  {
                    responseType: "blob",
                  }
                )
                .then(({ data }) => {
                  let blob = new Blob([data]);
                  that.$refs.img1.src = window.URL.createObjectURL(blob);
                  that.$refs.img1s.src = window.URL.createObjectURL(blob);
                });
            }
            if (
              res.data.result.transportOperationLicenseFileIds == "" ||
              res.data.result.transportOperationLicenseFileIds == null
            ) {
              that.idImg2 = false;
            } else {
              that.idImg2 = true;
              that.$http
                .get(
                  "/api/File/Attachment/" +
                    res.data.result.transportOperationLicenseFileIds,
                  {
                    responseType: "blob",
                  }
                )
                .then(({ data }) => {
                  let blob = new Blob([data]);
                  that.$refs.img2.src = window.URL.createObjectURL(blob);
                  that.$refs.img2s.src = window.URL.createObjectURL(blob);
                });
            }
            if (
              res.data.result.legalFileIds == "" ||
              res.data.result.legalFileIds == null
            ) {
              that.idImg3 = false;
            } else {
              that.idImg3 = true;
              that.$http
                .get("/api/File/Attachment/" + res.data.result.legalFileIds, {
                  responseType: "blob",
                })
                .then(({ data }) => {
                  let blob = new Blob([data]);
                  that.$refs.img3.src = window.URL.createObjectURL(blob);
                  that.$refs.img3s.src = window.URL.createObjectURL(blob);
                });
            }
            if (
              res.data.result.contactFileIds == "" ||
              res.data.result.contactFileIds == null
            ) {
              that.idImg4 = false;
            } else {
              that.idImg4 = true;
              that.$http
                .get("/api/File/Attachment/" + res.data.result.contactFileIds, {
                  responseType: "blob",
                })
                .then(({ data }) => {
                  let blob = new Blob([data]);
                  that.$refs.img4.src = window.URL.createObjectURL(blob);
                  that.$refs.img4s.src = window.URL.createObjectURL(blob);
                });
            }
          }
        });
    },

    // 查看里面的核验
    verification(id) {
      var that = this;
      var loading = that.$loading({
        lock: true,
        text: "核验中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      that.$http
        .post("/api/services/app/Tenant/AuditMessage", {
          id: id,
        })
        .then((res) => {
          loading.close();
          if (res.data.result.value == "ok") {
            that.$message({
              message: res.data.result.name,
              type: "success",
            });
          } else {
            that.$message({
              message: res.data.result.name,
              type: "warning",
            });
          }
        });
    },

    // 图片放大
    imgMax(name) {
      if (name == "img1s") {
        this.imgMax1 = true;
      }
      if (name == "img2s") {
        this.imgMax2 = true;
      }
      if (name == "img3s") {
        this.imgMax3 = true;
      }
      if (name == "img4s") {
        this.imgMax4 = true;
      }
    },
    closeImgMax() {
      this.imgMax1 = false;
      this.imgMax2 = false;
      this.imgMax3 = false;
      this.imgMax4 = false;
    },
    // 获取收费类型
    getChargeType() {
      var that = this;
      that.$http
        .get("/api/Enum/GetDropDownList?EnumName=tenantPaymentType")
        .then((res) => {
          that.chargeTypeList = res.data.result;
        });
    },
    // 设置收费
    setCharge(row) {
      this.dialogCharge = true;
      this.charge.id = row.id;
      this.charge.name = row.name;
      this.charge.tenancyName = row.tenancyName;
      this.charge.time = row.overTime;
      this.charge.type = row.tenantPaymentType;
    },
    // 设置收费提交
    submitCharge() {
      var that = this;
      if (that.charge.type == "") {
        that.$message.error("公司缴费类型不能为空");
        return;
      }
      if (that.charge.type == 1) {
        that.charge.time = "";
        that.$http
          .post("/api/services/app/Tenant/ChargeSet", {
            id: that.charge.id,
            tenantPaymentType: that.charge.type,
          })
          .then((res) => {
            if (res.data.success == true) {
              that.$message({
                message: "设置成功",
                type: "success",
              });

              that.dialogCharge = false;
              that.getData();
            }
          });
      }
      if (that.charge.type == 2) {
        if (that.charge.time == "" || that.charge.time == null) {
          that.$message.error("选择按年缴费后，包年到期时间不能为空");
          return;
        }
        that.$http
          .post("/api/services/app/Tenant/ChargeSet", {
            id: that.charge.id,
            tenantPaymentType: that.charge.type,
            overTime: that.charge.time,
          })
          .then((res) => {
            if (res.data.success == true) {
              that.$message({
                message: "设置成功",
                type: "success",
              });

              that.dialogCharge = false;
              that.getData();
            }
          });
      }
    },

    // 调研
    auditClick(row) {
      this.dialogAudit = true;
      this.form = row;
    },
    // 调研提交
    submitAudit() {
      var that = this;
      if (that.form.region == false || that.form.region == true) {
        var loading = that.$loading({
          lock: true,
          text: "提交中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        that.$http
          .post("/api/services/app/Tenant/Audit", {
            id: that.form.id,
            state: that.form.region,
            auditRemark: that.form.explain,
          })
          .then((res) => {
            if (res.data.result.value == "ok") {
              that.$message({
                message: "审核成功",
                type: "success",
                duration: 2000,
              });
              setTimeout(() => {
                that.dialogAudit = false;
                loading.close();
                that.getData();
              }, 2000);
            }
          })
          .catch((errors) => {
            loading.close();
          });
      } else {
        that.$message.error("审核状态不能为空");
      }
    },
    handleSizeChange(val) {
      var that = this;
      that.MaxResultCount = val;
      that.getData();
    },
    // 选择下一页或者跳到第几页，重新赋值pagenum，再请求一次数据
    handleCurrentChange(val) {
      var that = this;
      that.SkipCount = (val - 1) * that.MaxResultCount;
      that.getData();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>

